import { Box, type SxProps, type Theme } from '@mui/material';
import { forwardRef } from 'react';

import type { ExtraProps } from './types.js';

export const BLOCKQUOTE_SX: SxProps<Theme> = {
  borderLeft: 4,
  borderColor: 'divider',
  paddingLeft: 2,
  paddingY: 1,
  marginLeft: 0,
  marginRight: 0,
  backgroundColor: 'action.hover',
  borderRadius: 0.5,
  '& > p:first-of-type': {
    marginTop: 0,
  },
  '& > p:last-of-type': {
    marginBottom: 0,
  },
};

export const MarkdownBlockquote = forwardRef<HTMLQuoteElement, ExtraProps>((props, ref) => {
  const { node, ...rest } = props;
  return <Box ref={ref} component="blockquote" sx={BLOCKQUOTE_SX} {...rest} />;
});
MarkdownBlockquote.displayName = 'MarkdownBlockquote';
